module.exports = __webpack_public_path__ + "static/media/Finansii-Web-en.16c70e2e.jpg";